(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting || this.dataset.skip == 'true') return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              let event = new Event("recommendations-loaded", {bubbles: true});
              document.body.dispatchEvent(event);
            }

            if (html.querySelector('.grid__item')) {
            }
            this.classList.add('product-recommendations--loaded');
          })
          .catch(e => {
            console.error(e);
          });
      }

      const emptyRecommendations = this.querySelector('.product-recommendations-wrapper[data-empty="true"]');

        if (emptyRecommendations) {
            if (this.parentElement) {
                const titleElement = this.parentElement.querySelector('.title');
                if (titleElement && this.getAttribute('default-title')) {
                    titleElement.textContent = this.getAttribute('default-title');
                }
            }
        }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
